import { useState } from 'react';

import QrCode2Icon from '@mui/icons-material/QrCode2';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import ParticipantQrDialog from '../../components/ParticipantQrDialog';
import { ParticipantCellProps, useParticipantRowModel } from './shared';

export function ParticipantQrCell({ participant, callbacks }: ParticipantCellProps) {
  const { t, registrationState, displayName } = useParticipantRowModel(participant, callbacks);
  const [open, setOpen] = useState(false);
  const effectiveRegistrationId = callbacks.registrationId || participant.registration?.id;

  if (registrationState === 'unregistered' || !effectiveRegistrationId) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <>
      <Tooltip title={t('participants.showQr')}>
        <IconButton
          size="small"
          color="primary"
          onClick={e => {
            e.stopPropagation();
            setOpen(true);
          }}
          aria-label={t('participants.showQr')}
          {...(participant.id === callbacks.tourQrAnchorParticipantId
            ? { 'data-tour': 'my-participants-qr' }
            : {})}
        >
          <QrCode2Icon fontSize="small" />
        </IconButton>
      </Tooltip>
      <ParticipantQrDialog
        open={open}
        onClose={() => setOpen(false)}
        registrationId={effectiveRegistrationId}
        participantName={displayName}
      />
    </>
  );
}
